export enum UserGroups {
  ACCOUNT_MANAGERS = 'ACCOUNT_MANAGERS',
  ADMINS = 'ADMINS',
  AGENTS = 'AGENTS',
  OTA_USER = 'OTA_USER',
  ORDER_ADMINS = 'ORDER_ADMINS',
  MARKETING_MANAGERS = 'MARKETING_MANAGERS',
  TRAVELC_OPERATOR = 'TRAVELC_OPERATOR',
  TRAVELC_CALLCENTER = 'TRAVELC_CALLCENTER',
  TRAVELC_MICROSITE_ADMIN = 'TRAVELC_MICROSITE_ADMIN',
}
